import { Reducer } from 'redux';

import { loadSession } from '../services/authentication';
import { ActionTypes } from '../types/action-types';
import { ActionObject, AUTHENTICATION_STATE, ISession } from '../types/authentication';

export default ((state = loadSession(), action: ActionObject): ISession => {
  switch (action.type) {
    case ActionTypes.USER_LOGIN_FAILURE:
      return {
        ...state,
        id: '',
        state: AUTHENTICATION_STATE.LOGIN_FAILED,
      };
    case ActionTypes.USER_LOGIN_SUCCESS:
      return {
        ...state,
        id: action.session,
        state: AUTHENTICATION_STATE.LOGGED_IN
      };
  }
  return {...state};
}) as Reducer<ISession>;



// WEBPACK FOOTER //
// ./src/reducers/authentication.ts